"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleUploadImage = handleUploadImage;
function handleUploadImage(e) {
    return new Promise(function (resolve, reject) {
        var _a;
        var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        console.log(file);
        var MAX_SIZE = 8 * 1024 * 1024;
        var allowedFormats = ["image/jpeg", "image/png", "image/webp"];
        if (file) {
            if (file.size > MAX_SIZE) {
                // alert("Image max size is 8 MB");
                reject("File size exceeds limit");
                return;
            }
            if (!allowedFormats.includes(file.type)) {
                // alert("format is wrong");
                reject("Unsupported file format");
                return;
            }
            var reader_1 = new FileReader();
            reader_1.onload = function () {
                resolve(reader_1.result);
            };
            reader_1.onabort = function () {
                reject("Operation was aborted");
            };
            reader_1.onerror = function () {
                reject("Error reading file");
            };
            reader_1.readAsDataURL(file);
        }
        else {
            reject("No file selected");
        }
    });
}
